// import { request } from '@/utils'
import flat from './flat'

// 针对本次，app 外的使用 report_event_without_login，其他的依旧使用 report_event
const isApp = /bcz_app_([a-zA-Z]+)(_[a-zA-Z]+)?\/(\d*\.?\d*)/.test(navigator.userAgent)
const url = isApp
  ? 'https://system.baicizhan.com/api/system/report_event'
  : 'https://system.baicizhan.com/api/system/report_event_without_login'

const stat_group = 'bcz_mall-common'

const baseUrl = 'https://learn.baicizhan.com/api/mall/proxy/goodsdetail'

export function getDetailData(itemId, shopId) {
  return flat(`${baseUrl}/get_goods_info?shopId=${shopId}&itemId=${itemId}`)
}

/**
 *
 * @param {object} param
 * @param {boolean} param.val
 * @param {number} param.itemId
 * @param {number}[param.shopId ]
 * @returns
 */
export function updateLikeStatus(param) {
  const { val, ...ot } = param
  const url = val ? '/collect_goods' : '/cancel_collect_goods'
  return flat(`${baseUrl}${url}`, {
    method: 'POST',
    body: {
      ...ot,
    },
  })
}
